import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Header";
import { useParams } from 'react-router-dom';
import SkeletonBlogDetail from "../Components/SkeletonBlogDetail"; // Import the skeleton component

const BlogDetailPage = () => {
  const [blog, setBlog] = useState({});
  const [loading, setLoading] = useState(true); // Add loading state
  const { id } = useParams();

  useEffect(() => {
    // Fetch Blog Data
    const fetchData = async () => {
      try {
        const response = await fetch(`http://localhost:5000/api/blogs/${id}`);
        const data = await response.json();
        setBlog(data);
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching blog:", error);
        setLoading(false); // Set loading to false even on error
      }
    };
    fetchData();
  }, [id]);

  return (
    <>
      <div>
        <Navbar color={"bg-white text-teal-950"} />
      </div>
      <div className="max-w-screen-xl mx-auto p-5 sm:p-8 md:p-10 relative">
        {/* Display Skeleton while loading */}
        {loading ? (
          <SkeletonBlogDetail />
        ) : (
          <>
            {/* Blog Header with Image */}
            {blog.image && (
              <div
                className="bg-cover bg-center text-center overflow-hidden"
                style={{
                  height: "450px",
                  backgroundImage: `url(${blog.image})`,
                }}
              />
            )}

            {/* Blog Content */}
            <div className="max-w-xl mx-auto">
              <div className="mt-3 bg-white rounded-b lg:rounded-b-none lg:rounded-r flex flex-col justify-between leading-normal">
                {/* Blog Title */}
                <div>
                  <h1 className="text-gray-900 font-bold text-3xl mb-2">
                    {blog.title}
                  </h1>

                  {/* Blog Author */}
                  <p className="text-gray-700 text-s mt-2">
                    Written By:{" "}
                    <a
                      href="#"
                      className="text-emerald-600 font-medium hover:text-gray-900 transition duration-500 ease-in-out"
                    >
                      {blog.author}
                    </a>
                  </p>

                  {/* Blog Content */}
                  <div className="text-base leading-8 my-5">
                    <p>{blog.content}</p>
                  </div>

                  {/* Optional Subsections or Sections */}
                  {blog.sections && blog.sections.map((section, index) => (
                    <div key={index} className="my-8">
                      <h3 className="text-2xl font-bold my-5">
                        {section.heading}
                      </h3>
                      {section.image && (
                        <img
                          src={section.image}
                          alt={`Section ${index + 1}`}
                          className="w-full h-auto object-cover rounded-lg shadow-md my-5"
                        />
                      )}
                      <p className="text-base leading-8 my-5 text-justify">
                        {section.text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default BlogDetailPage;
